/**
 * Page liste des personnages sauvegardes.
 */

import type { Personnage } from '@domain/personnage';
import { importPersonnageJSON, listPersonnages, removePersonnage } from '@persistence/personnages';
import { html } from 'lit';
import { buildHref } from '../router';

export async function renderPersonnageListPage(): Promise<unknown> {
  const personnages = await listPersonnages();

  if (personnages.length === 0) {
    return html`
      <div class="perso-list-page">
        <header class="perso-list-header">
          <h1 class="perso-list-title" data-morph data-morph-duration="1200">Mes Heros</h1>
        </header>
        <div class="perso-list-empty">
          <div class="perso-list-empty-icon">⚔</div>
          <p class="perso-list-empty-text">Aucun heros ne repond a l'appel.</p>
          <p class="perso-list-empty-sub">Votre destin vous attend.</p>
          <a class="perso-list-create-btn" href=${buildHref('personnage-new')}>
            Forger un heros
          </a>
        </div>
      </div>
    `;
  }

  return html`
    <div class="perso-list-page">
      <header class="perso-list-header">
        <h1 class="perso-list-title" data-morph data-morph-duration="1200">Mes Heros</h1>
        <div style="display: flex; gap: var(--space-2);">
          <label class="perso-list-import-btn">
            Importer
            <input type="file" accept=".json" hidden @change=${async (e: Event) => {
              const file = (e.target as HTMLInputElement).files?.[0];
              if (file) {
                await importPersonnageJSON(file);
                window.location.reload();
              }
            }} />
          </label>
          <a class="perso-list-new-btn" href=${buildHref('personnage-new')}>
            + Nouveau
          </a>
        </div>
      </header>
      <div class="perso-list-count">${personnages.length} personnage${personnages.length > 1 ? 's' : ''}</div>
      <div class="personnage-list">
        ${personnages.map((p, i) => renderPersonnageCard(p, i))}
      </div>
    </div>
  `;
}

function renderPersonnageCard(p: Personnage, index: number) {
  return html`
    <div class="personnage-card" style="animation-delay: ${index * 60}ms">
      <a href=${buildHref('personnage-fiche', { id: p.id })} class="personnage-card-link">
        <div class="personnage-card-main">
          <span class="personnage-card-name">${p.nom}</span>
          <span class="personnage-card-meta">
            Niveau ${p.niveau}
          </span>
        </div>
        <div class="personnage-card-tags">
          <span class="personnage-card-tag">${p.profilId}</span>
          <span class="personnage-card-tag">${p.peupleId}</span>
        </div>
      </a>
      <button
        class="personnage-card-delete"
        title="Supprimer ${p.nom}"
        @click=${async () => {
          if (confirm(`Supprimer ${p.nom} ? Cette action est irreversible.`)) {
            await removePersonnage(p.id);
            window.location.reload();
          }
        }}
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M2 4h12M5.33 4V2.67a1.33 1.33 0 011.34-1.34h2.66a1.33 1.33 0 011.34 1.34V4M6.67 7.33v4M9.33 7.33v4M12.67 4v9.33a1.33 1.33 0 01-1.34 1.34H4.67a1.33 1.33 0 01-1.34-1.34V4"/>
        </svg>
      </button>
    </div>
  `;
}
